// Browser-side Supabase client (Vite). Worker overrides this file
// during Docker build (see worker/overrides/integrations/supabase/client.ts)
// to use service-role key instead of anon for RLS-bypassing operations.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { env } from '@/lib/env';

const SUPABASE_URL = env('VITE_SUPABASE_URL') || '';
const SUPABASE_PUBLISHABLE_KEY = env('VITE_SUPABASE_ANON_KEY') || '';

const isBrowser = typeof window !== 'undefined';

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: isBrowser ? localStorage : undefined,
    persistSession: isBrowser,
    autoRefreshToken: isBrowser,
  }
});